import project from './modules/project';
import zbproject from './modules/zb-project';
import projectflow from './modules/project-flow';
import liucheng from './modules/liu-cheng';
import yqz from './modules/yqz';//云签章
import zbr from './modules/zbr';//招标人列表
import contract from './modules/contract';//合同
import workbench from './modules/workbench';//工作台
import tool from './modules-tool';
import revision from './modules-revision';//2022改版
export default [
    {
        path: 'bidding',
        component: () => import(/*webpackChunkName: 'bidding-bidding'*/ '@views/layout/index'),
        children: [
            project,
            zbproject,
            projectflow,
            liucheng,
            yqz,
            zbr,
            contract,
            workbench,
        ]
    },
    tool,
    revision,
]